'use strict';

exports.__esModule = true;
exports.LoadingComponent = exports.withLoadingComponent = exports.LoadingComponentContainer = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  20% {\n    opacity: 0.2;\n  }\n  40% {\n    opacity: 0.4;\n  }\n  60% {\n    opacity: 0.6;\n  }\n  80% {\n    opacity: 0.8;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  20% {\n    opacity: 0.2;\n  }\n  40% {\n    opacity: 0.4;\n  }\n  60% {\n    opacity: 0.6;\n  }\n  80% {\n    opacity: 0.8;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  background-color: ', ';\n  z-index: 8888;\n  text-align: center;\n\n  left: 0;\n  top: 0;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n\n  .loadingText {\n    font-family: \'PlayfairDisplay\';\n    font-size: 40px;\n    font-weight: bold;\n    color: #00234b;\n    ', ';\n  }\n\n  .loadingAnimation {\n    margin-top: 40px;\n    ', ';\n  }\n\n  .loadingAnimation > div {\n    width: 50px;\n    height: 6px;\n    background: #b5985b;\n    display: inline-block;\n    animation: ', ' 1.1s infinite ease-in-out both;\n    margin-right: 6px;\n    ', ';\n  }\n\n  .loadingAnimation .loadingAnimation__item1 {\n    animation-delay: -0.8s;\n  }\n\n  .loadingAnimation .loadingAnimation__item2 {\n    animation-delay: -0.6s;\n  }\n\n  .loadingAnimation .loadingAnimation__item3 {\n    animation-delay: -0.4s;\n  }\n\n  .loadingAnimation .loadingAnimation__item4 {\n    animation-delay: -0.2s;\n  }\n\n  .loadingAnimation .loadingAnimation__item5 {\n    animation-delay: -0s;\n  }\n'], ['\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  background-color: ', ';\n  z-index: 8888;\n  text-align: center;\n\n  left: 0;\n  top: 0;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n\n  .loadingText {\n    font-family: \'PlayfairDisplay\';\n    font-size: 40px;\n    font-weight: bold;\n    color: #00234b;\n    ', ';\n  }\n\n  .loadingAnimation {\n    margin-top: 40px;\n    ', ';\n  }\n\n  .loadingAnimation > div {\n    width: 50px;\n    height: 6px;\n    background: #b5985b;\n    display: inline-block;\n    animation: ', ' 1.1s infinite ease-in-out both;\n    margin-right: 6px;\n    ', ';\n  }\n\n  .loadingAnimation .loadingAnimation__item1 {\n    animation-delay: -0.8s;\n  }\n\n  .loadingAnimation .loadingAnimation__item2 {\n    animation-delay: -0.6s;\n  }\n\n  .loadingAnimation .loadingAnimation__item3 {\n    animation-delay: -0.4s;\n  }\n\n  .loadingAnimation .loadingAnimation__item4 {\n    animation-delay: -0.2s;\n  }\n\n  .loadingAnimation .loadingAnimation__item5 {\n    animation-delay: -0s;\n  }\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var loading = (0, _styledComponents.keyframes)(_templateObject);

var LoadingComponentContainer = exports.LoadingComponentContainer = _styledComponents2.default.main(_templateObject2, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.small && 'font-size: 28px;';
}, function (props) {
  return props.small && 'margin-top: 28px;';
}, loading, function (props) {
  return props.small && 'width: 40px; height: 4px; margin-right: 4px;';
});

LoadingComponentContainer.displayName = 'LoadingComponentContainer';

var LoadingComponentDef = function LoadingComponentDef(props) {
  return _react2.default.createElement(
    LoadingComponentContainer,
    props,
    _react2.default.createElement(
      'div',
      { className: 'loadingText' },
      props.text
    ),
    _react2.default.createElement(
      'div',
      { className: 'loadingAnimation' },
      _react2.default.createElement('div', { className: 'loadingAnimation__item1' }),
      _react2.default.createElement('div', { className: 'loadingAnimation__item2' }),
      _react2.default.createElement('div', { className: 'loadingAnimation__item3' }),
      _react2.default.createElement('div', { className: 'loadingAnimation__item4' }),
      _react2.default.createElement('div', { className: 'loadingAnimation__item5' })
    )
  );
};

LoadingComponentDef.defaultProps = {
  text: 'Loading...',
  backgroundColor: '#e2e2e2'
};

LoadingComponentDef.propTypes = process.env.NODE_ENV !== "production" ? {
  text: _propTypes2.default.string, // Display specific text
  backgroundColor: _propTypes2.default.string, // Background color "rgba(255, 255, 255, 0.0)"
  small: _propTypes2.default.bool // Display small size of LoadingCompoent
} : {};

var withLoadingComponent = exports.withLoadingComponent = function withLoadingComponent(Comp) {
  return function (props) {
    return props.loading ? _react2.default.createElement(LoadingComponentDef, null) : _react2.default.createElement(Comp, props);
  };
};

var LoadingComponent = exports.LoadingComponent = LoadingComponentDef;